<template>
  <v-sheet class="d-print-none" outlined>
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="500"
      hide-default-footer
      item-key="id"
      dense
      :no-data-text="t('没有数据')"
    >
      <template v-slot:top>
        <v-card-title class="py-1" flat>
          <v-toolbar-title>
            {{ titleText }}
            <div class="red--text subtitle-1" style="display: inline-block">
              {{
                haveChange
                  ? lang == 'en'
                    ? 'Have changes, please save'
                    : '-有文件变动，请注意保存'
                  : ''
              }}
            </div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!disabled && !readonly"
            @click="onButtonClick"
            :loading="isSelecting"
            small
            outlined
            tile
            class="mx-1"
          >
            <v-icon left>mdi-plus-circle</v-icon>
            {{ t('上传') }}
          </v-btn>
          <input
            ref="uploader"
            class="d-none"
            type="file"
            :accept="accept"
            multiple
            @change="onFileChanged"
          />
        </v-card-title>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <div v-if="item.isDelete" class="text-decoration-line-through">
          {{ item.name }}
        </div>
        <div v-else-if="!item.initial" class="blue--text">
          {{ item.name }}-{{ t('新增') }}
        </div>
        <div v-else>
          {{ item.name }}
          <span class="red--text">
            {{ item.filePath ? '' : '(未同步,无法下载)' }}
          </span>
        </div>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <!-- <v-btn
          v-if="item.filePath"
          :href="`/api/system/file/download?fileName=${item.name}&filePath=${item.filePath}`"
          target="_blank"
          icon
          small
          class="mr-1"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn> -->
        <v-btn
          v-if="item.filePath"
          :href="`/api/system/file/download?fileName=${encodeURIComponent(
            item.name,
          )}&filePath=${item.filePath}`"
          target="_blank"
          icon
          small
          class="mr-1"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>

        <!-- 文件暂未同步，无法下载 -->
        <!--  -->
        <template>
          <v-btn icon v-if="!item.isDelete" small @click="delAttachment(item)">
            <v-icon color="red">mdi-delete-empty</v-icon>
          </v-btn>
          <v-btn icon v-else small @click="cancelDel(item)">
            <v-icon>mdi-delete-off</v-icon>
          </v-btn>
        </template>
      </template>
    </v-data-table>
  </v-sheet>
</template>
<script>
/**
 * @description: 附件列表
 * @props {Array} attachments 附件列表
 * @event {Function} changeAttachment 附件变动回调,第一个参数为附件id列表
 */
export default {
  name: 'v-attach-list',
  data() {
    return {
      lang: this.getLangFromCookie(),
      messages: {
        zh: {
          附件选择: '附件选择',
          名称: '名称',
          '大小(kb)': '大小(kb)',
          上传时间: '上传时间',
          上传人: '上传人',
          操作: '操作',
          上传: '上传',
          新增: '新增',
          没有数据: '没有数据',
          附件列表: '附件列表',
        },
        en: {
          附件选择: 'Attachment Selection',
          名称: 'Name',
          '大小(kb)': 'Size (kb)',
          上传时间: 'Upload Time',
          上传人: 'Uploader',
          操作: 'Action',
          上传: 'Upload',
          新增: 'New',
          没有数据: 'No data',
          附件列表: 'Attachment List',
        },
      },
      headers: [],
      items: [],
      isSelecting: false,
    }
  },

  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: [Boolean, String],
      default: false,
    },
    readonly: {
      type: [Boolean, String],
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    shipCode: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
      default: 'all',
    },
  },

  computed: {
    titleText() {
      return this.title || this.t('附件列表')
    },
    haveChange() {
      return this.items.some(
        (item) =>
          // 被删除且是初始化 或者 没有被删除且是不是初始化
          (item.isDelete && item.initial) || (!item.initial && !item.isDelete),
      )
    },
  },

  watch: {
    attachments: {
      handler(val) {
        this.items = val.map((item) => {
          return {
            ...item,
            fileSize: item.fileSize,
            isDelete: false,
            initial: true,
          }
        })
      },
      deep: true,
      immediate: true,
    },
    items: {
      handler(val) {
        const attachmentIds = val
          .filter((item) => !item.isDelete)
          .map((item) => item.id)
        this.$emit('change', attachmentIds)
      },
      deep: true,
    },
  },

  methods: {
    setHeaders() {
      this.headers = [
        { text: this.t('名称'), value: 'name' },
        { text: this.t('大小(kb)'), value: 'fileSize' },
        { text: this.t('上传时间'), value: 'createTime' },
        { text: this.t('上传人'), value: 'userName' },
        { text: this.t('操作'), value: 'action', sortable: false },
      ]
    },
    getLangFromCookie() {
      const values = String(document.cookie || '')
        .split(';')
        .map((c) => c.trim())
        .filter((c) => c.startsWith('language='))
        .map((c) => c.substring('language='.length))
      const lang = values.length ? values[values.length - 1] : 'zh'
      return lang === 'en' ? 'en' : 'zh'
    },
    t(key) {
      return this.messages[this.lang]?.[key] || key
    },
    onButtonClick() {
      window.addEventListener('focus', () => {}, { once: true })
      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.isSelecting = true
      const files = Array.from(e.target.files)

      // 遍历所有选中的文件进行上传
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        let formData = new FormData()
        formData.append('file', file)
        formData.append('shipCode', this.shipCode)

        try {
          const { errorRaw, data } = await this.postAsync(
            '/system/file/upload',
            formData,
          )
          if (!errorRaw) {
            this.items.push({
              ...data,
              fileSize: data.fileSize / 1024,
              initial: false,
              isDelete: false,
            })
          }
        } catch (error) {
          console.error(`上传文件 ${file.name} 失败:`, error)
        }
      }

      // 清空文件选择器的值，以便可以重复选择相同的文件
      e.target.value = ''
      this.isSelecting = false
    },
    delAttachment(item) {
      this.items.find((i) => i.id === item.id).isDelete = true
    },
    cancelDel(item) {
      this.items.find((i) => i.id === item.id).isDelete = false
    },
  },

  created() {
    this.setHeaders()
  },
}
</script>

<style></style>
